function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (buttonText, config, content, title) {
      pug_html = pug_html + "\u003Cdiv class=\"content-scroll content-fit content-ver text-center block-v-md\"\u003E\u003Csection class=\"content-scroll-inner\"\u003E\u003Chgroup class=\"block-v-md\"\u003E\u003Ch2 class=\"slide-up text-xxl\" id=\"title\" tabindex=\"0\"\u003E" + (null == (pug_interp = title) ? "" : pug_interp) + "\u003C\u002Fh2\u003E\u003Cp class=\"slide-up delay-1 text-md\"\u003E" + (null == (pug_interp = content) ? "" : pug_interp) + "\u003C\u002Fp\u003E\u003C\u002Fhgroup\u003E";
if (config.contextRequiresExitButton) {
pug_html = pug_html + "\u003Cdiv class=\"block-v-md\"\u003E\u003Cbutton class=\"btn btn-solid slide-up\"\u003E" + (null == (pug_interp = buttonText) ? "" : pug_interp) + "\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "buttonText" in locals_for_with ?
        locals_for_with.buttonText :
        typeof buttonText !== 'undefined' ? buttonText : undefined, "config" in locals_for_with ?
        locals_for_with.config :
        typeof config !== 'undefined' ? config : undefined, "content" in locals_for_with ?
        locals_for_with.content :
        typeof content !== 'undefined' ? content : undefined, "title" in locals_for_with ?
        locals_for_with.title :
        typeof title !== 'undefined' ? title : undefined));
    ;;return pug_html;};module.exports=template;